import HthBanner from "../../assets/HTHWebBanner.png";
import OpenOutcryBanner from "../../assets/OpenOutcryWebBanner.png";

export const PINTS_EVENTS = {
  horseThief: {
    key: "pints-horsethief",
    slug: "pints-horsethief",
    path: "/pints/horsethief",
    event_id: "chi26-pints-horsethief-2026-05-21",
    title: "Pints for Patriots – Horse Thief Hollow",
    dateLabel: "May 21, 2026",
    timeLabel: "4:00-7:00 PM",
    venueName: "Horse Thief Hollow Brewing Co.",
    addressLines: ["10426 S Western Ave", "Chicago, IL 60643"],
    webBanner: HthBanner,
    mode: "multi",
    limits: { maxAttendees: 6, capacityTotal: 120 },
    defaultMailingListOptIn: true,
    mailingListInterests: ["Pints for Patriots updates"],
  },
  openOutcry: {
    key: "pints-openoutcry",
    slug: "pints-openoutcry",
    path: "/pints/openoutcry",
    event_id: "chi26-pints-openoutcry-2026-05-21",
    title: "Pints for Patriots – Open Outcry",
    dateLabel: "May 21, 2026",
    timeLabel: "4:00-7:00 PM",
    venueName: "Open Outcry Brewing",
    addressLines: ["10934 S Western Ave", "Chicago, IL 60643"],
    webBanner: OpenOutcryBanner,
    mode: "multi",
    limits: { maxAttendees: 6, capacityTotal: 120 },
    defaultMailingListOptIn: true,
    mailingListInterests: ["Pints for Patriots updates"],
  },
};
